import * as React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../Context/LanguageContext";
import NotFoundCard from "../../ReusableComponent/NotFoundCard";
import CheckListInspectionAction from "../../../Actions/CheckListInspectionAction";

export default function CheckListAccordionView({
  checkList,
  setCheckListTitle,
}) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const [expandedPanels, setExpandedPanels] = React.useState({
    0: true,
    1: true,
  });

  const checkListType = ["nonGlobalChecklist", "globalChecklist"];

  const handleCheckListClick = (_checkListId) => {
    setGlobalSpinner(true);
    CheckListInspectionAction.getCheckListDetails(_checkListId);
  };

  const handleAccordionChange = (panelIndex) => (event, isExpanded) => {
    setExpandedPanels((prev) => ({
      ...prev,
      [panelIndex]: isExpanded,
    }));
  };

  const getExpandIcon = (isExpanded) =>
    isExpanded ? (
      <KeyboardArrowUpIcon className="public-checklist-arrowIcon" />
    ) : (
      <KeyboardArrowDownIcon className="public-checklist-arrowIcon" />
    );

  return (
    <>
      {checkListType.map((typeChecklist, outerIndex) => (
        <Accordion
          key={outerIndex}
          expanded={expandedPanels[outerIndex]}
          onChange={handleAccordionChange(outerIndex)}
          elevation={0}
          sx={{
            backgroundColor: "transparent",
            "&:before": { display: "none" },
            mb: 1,
          }}
        >
          <AccordionSummary
            expandIcon={getExpandIcon(expandedPanels[outerIndex])}
            sx={{
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
              minHeight: "40px !important",
              "& .MuiAccordionSummary-content": {
                margin: 0,
                alignItems: "center",
              },
              "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                transform: "rotate(0deg)",
              },
            }}
          >
            <Typography
              sx={{ fontWeight: 600, fontSize: "16px" }}
              className="public-checklist-sectionHeader"
            >
              {typeChecklist === "globalChecklist"
                ? localization.globalChecklist
                : localization.equipmentGrpChecklist}
            </Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ p: 2 }}>
            <Grid container spacing={2}>
              {checkList && checkList[typeChecklist]?.length > 0 ? (
                checkList[typeChecklist].map((item, index) => (
                  <Grid item key={index} xs={12} sm={6} md={2}>
                    <Card
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "180px",
                        border: "1px solid #eee !important",
                      }}
                      onClick={() => {
                        setCheckListTitle(item.title);
                        handleCheckListClick(item.id);
                      }}
                    >
                      <CardContent
                        sx={{
                          flex: 1,
                          p: "12px 16px 0 16px",
                          display: "flex",
                          flexDirection: "column",
                          overflow: "hidden",
                        }}
                      >
                        {/* Title */}
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: "15px",
                            mb: "6px",
                            lineHeight: 1.3,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={item.title}
                        >
                          {item.title}
                        </Typography>

                        {/* Scrollable description */}
                        <Box
                          sx={{
                            flex: 1,
                            overflowY: "auto",
                            pr: 1,
                            "&::-webkit-scrollbar": { width: "4px" },
                            "&::-webkit-scrollbar-thumb": {
                              backgroundColor: "rgba(0,0,0,0.2)",
                              borderRadius: "4px",
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "13px",
                              color: "text.secondary",
                              lineHeight: 1.4,
                            }}
                          >
                            {item.description}
                          </Typography>
                        </Box>
                      </CardContent>

                      {/* Button */}
                      <CardActions
                        sx={{
                          justifyContent: "center",
                          p: "8px 16px 12px 16px",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "12px",
                            minWidth: "120px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setCheckListTitle(item.title);
                            handleCheckListClick(item.id);
                          }}
                        >
                          {localization.startInspection}
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <NotFoundCard title={localization.noChecklistConfigured} />
                </Grid>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      ))}

      {checkList &&
        checkList["globalChecklist"]?.length === 0 &&
        checkList["nonGlobalChecklist"]?.length === 0 && (
          <NotFoundCard title={localization.noChecklistConfigured} />
        )}
    </>
  );
}
